import { render, staticRenderFns } from "./PWR01G04.vue?vue&type=template&id=7fa7ff06"
import script from "./PWR01G04.vue?vue&type=script&lang=js"
export * from "./PWR01G04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa7ff06')) {
      api.createRecord('7fa7ff06', component.options)
    } else {
      api.reload('7fa7ff06', component.options)
    }
    module.hot.accept("./PWR01G04.vue?vue&type=template&id=7fa7ff06", function () {
      api.rerender('7fa7ff06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pwr/PWR01G04.vue"
export default component.exports